import { render, staticRenderFns } from "./FeatureBulletsFeature.vue?vue&type=template&id=0d1928d0&"
import script from "./FeatureBulletsFeature.vue?vue&type=script&lang=ts&"
export * from "./FeatureBulletsFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FeatureBulletsFeature.vue"
export default component.exports